import axios from 'axios'
import {TemplateTypes} from './_constants'
const API_URL = process.env.REACT_APP_BASE_API_URL

const GET_TEMPLATES = `${API_URL}/signing/templates`
const GET_DOCUMENTS = `${API_URL}/signing/documents`

export const getTemplatesApi = (
  companyId: number,
  page: number,
  limit: number,
  search: string,
  type?: string
) => {
  return axios.get(
    `${GET_TEMPLATES}?companyId=${companyId}&page=${page}&limit=${limit}&search=${search}${
      type ? `&type=${type}` : ''
    }`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const deleteTemplateApi = (templateId: number) => {
  return axios.delete(`${GET_TEMPLATES}/${templateId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getTemplateTokenApi = (
  isTemplateVisible: boolean = true,
  templateName?: string,
  templateType?: string,
  companyId?: number,
  templateId?: number,
  isUpdateTemplate: boolean = false
) => {
  return axios.post(
    `${GET_TEMPLATES}/token`,
    {
      templateName,
      templateType,
      companyId,
      templateId,
      isUpdateTemplate,
      isTemplateVisible,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const templateChangeApi = (
  templateName: string,
  templateType: TemplateTypes,
  companyId: number,
  templateId?: number,
  docusealId?: number
) => {
  return axios.put(
    `${GET_TEMPLATES}?companyId=${companyId}${templateId ? `&templateId=${templateId}` : ''}${
      docusealId ? `&docusealId=${docusealId}` : ''
    }`,
    {
      templateName,
      templateType,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const duplicateTemplateTokenApi = (templateId: number) => {
  return axios.post(
    `${GET_TEMPLATES}/${templateId}/duplicate`,
    {},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const exportTemplates = (companyId: number) => {
  return axios.post(
    `${GET_TEMPLATES}/csv/export`,
    {companyId},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const exportDocuments = (companyId: number) => {
  return axios.post(
    `${GET_DOCUMENTS}/csv/export`,
    {companyId},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getTemplateTypeApi = (companyId: number, templateId?: string, docusealId?: number) => {
  return axios.get(
    `${GET_TEMPLATES}/type?companyId=${companyId}${templateId ? `&templateId=${templateId}` : ''}${
      docusealId ? `&docusealId=${docusealId}` : ''
    }`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getDocumentsApi = (
  companyId: number,
  page: number,
  limit: number,
  search: string,
  status?: string,
  signatureStatus?: string
) => {
  return axios.get(
    `${GET_DOCUMENTS}?companyId=${companyId}&page=${page}&limit=${limit}&search=${search}${
      status ? `&status=${status}` : ''
    }${signatureStatus ? `&signatureStatus=${signatureStatus}` : ''}`,
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getTemplatesForDropdownApi = (companyId: number) => {
  return axios.get(`${GET_DOCUMENTS}/templates?companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getTemplateApi = (templateId: number, companyId: number) => {
  return axios.get(`${GET_TEMPLATES}/${templateId}?companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getTemplateByDocusealIdApi = (docusealId: number, companyId: number) => {
  return axios.get(`${GET_TEMPLATES}/template/${docusealId}?companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const createDocumentSubmission = (values: any) => {
  return axios.post(
    `${GET_DOCUMENTS}`,
    {
      ...values,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const updateDocumentSubmission = (submissionId: number, values: any) => {
  return axios.put(
    `${GET_DOCUMENTS}/${submissionId}`,
    {
      ...values,
    },
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const getDocumentSubmissionApi = (submissionId: number, companyId: number) => {
  return axios.get(`${GET_DOCUMENTS}/${submissionId}?companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const resendDocumentSignatoryEmailApi = (signatoryId: number, companyId: number) => {
  return axios.post(
    `${GET_DOCUMENTS}/signatory/${signatoryId}/send/email?companyId=${companyId}`,
    {},
    {
      validateStatus(status) {
        return true
      },
    }
  )
}

export const cancelDocument = (submissionId: number, companyId: number) => {
  return axios.delete(`${GET_DOCUMENTS}/${submissionId}?companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const getDashboardCountsApi = (companyId: number) => {
  return axios.get(`${API_URL}/signing/count?companyId=${companyId}`, {
    validateStatus(status) {
      return true
    },
  })
}

export const updateSignatureStatusApi = (signatoryId:number,companyId:number) =>{
  return axios.put(`${GET_DOCUMENTS}/signatory/${signatoryId}?companyId=${companyId}`,{}, {
    validateStatus(status) {
      return true
    },
  })
}

